var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopUpLinerGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9008 15.0012H15.5001M15.5001 15.0012H11.0993M15.5001 15.0012V19.402M15.5001 15.0012L15.5001 10.6005M27.2354 15.002C27.2354 21.4832 21.9813 26.7373 15.5001 26.7373C9.01881 26.7373 3.76471 21.4832 3.76471 15.002C3.76471 8.5207 9.01881 3.2666 15.5001 3.2666C21.9813 3.2666 27.2354 8.5207 27.2354 15.002Z",
    stroke: "#e6e7eb",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUpLinerGray);
export default __webpack_public_path__ + "static/media/TopUpLinerGray.5abf7940c451d0405b5400e60d0f813c.svg";
export { ForwardRef as ReactComponent };